/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdQueryResponse,
  GetApiV1PersonIdPathParams,
  GetApiV1PersonId401,
  GetApiV1PersonId404,
  GetApiV1PersonId500,
} from "../../types/personRegisterController/GetApiV1PersonId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonId } from "../../clients/personRegisterController/getApiV1PersonId.ts";

export const getApiV1PersonIdQueryKey = (
  id: GetApiV1PersonIdPathParams["id"],
) => [{ url: "/api/v1/person/:id", params: { id: id } }] as const;

export type GetApiV1PersonIdQueryKey = ReturnType<
  typeof getApiV1PersonIdQueryKey
>;

export function getApiV1PersonIdQueryOptions(
  id: GetApiV1PersonIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1PersonId401 | GetApiV1PersonId404 | GetApiV1PersonId500
    >,
    GetApiV1PersonIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonId(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os detalhes completos de uma pessoa pelo ID. **(Requer Authorization para autenticação)**
 * @summary Obter pessoa por ID (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id}
 */
export function useGetApiV1PersonId<
  TData = GetApiV1PersonIdQueryResponse,
  TQueryData = GetApiV1PersonIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdQueryKey,
>(
  id: GetApiV1PersonIdPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdQueryResponse,
        ResponseErrorConfig<
          GetApiV1PersonId401 | GetApiV1PersonId404 | GetApiV1PersonId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1PersonIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1PersonId401 | GetApiV1PersonId404 | GetApiV1PersonId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
